import { Text, TextProps } from '@chakra-ui/react'
import { getNftColor } from '../../../helpers/getNftColor'
import { ElementType } from 'react'

export const GradientText = ({
  children,
  props,
  as = 'p',
  numberOfNfts,
}: {
  children: string | null | undefined
  props: TextProps
  numberOfNfts: number
  as?: ElementType
}) => {
  return (
    <Text
      as={as}
      bg={getNftColor(numberOfNfts)}
      bgBlendMode={'overlay'}
      bgGradient={`linear-gradient(90deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.25) 25%, rgba(255, 255, 255, 0.5) 33%, rgba(255, 255, 255, 0.25) 66%, rgba(255, 255, 255, 0.25) 75%, rgba(255, 255, 255, 0.25) 100%)`}
      backgroundClip={'text'}
      __css={{
        '-webkit-text-fill-color': 'transparent',
      }}
      {...props}
    >
      {children}
    </Text>
  )
}
